
import { mapActions, mapGetters } from "vuex";
import QrCodeVue from "qrcode.vue";
import { httpResetLogin } from "../../../configurations/axios";
import { SistemaMixin } from "@/modules/Application";
import Check from "vue-material-design-icons/Check";

export default {
  name: "app-contareceber-pix",
  mixins: [SistemaMixin],
  data() {
    return {
      contareceber: {},
      loader: true,
      mobileNumber: "",
      valorPix: 0,
      qrCodPix: null,
      dataValidadePix: null,
      benificiario: null,
      paymentEvent: {},
      isPayment: false,
      id_transaction_digital: null,
    };
  },
  components: {
    QrCodeVue,
    Check,
  },
  watch: {
    paymentEvent(newValue, oldValue) {
      if (newValue !== oldValue) {
        window.Echo.leaveChannel("boletoChannel");
      }
    },
  },
  computed: {
    ...mapGetters(["pageTitle", "layoutConfig"]),
  },
  methods: {
    ...mapActions(["setLoading"]),
    async verificaContasReceber() {
      this.setLoading(true);
      await this.$http
        .post("/boletos/webhook-transacations")
        .then(() => {
          window.Echo.channel("boletoChannel").listen(
            ".boletoEvent",
            (message) => {
              if (message) {
                message.message.payload.object.history.forEach((item) => {
                  if (
                    item.operation_type === "paid" &&
                    item.transaction === this.id_transaction_digital
                  ) {
                    this.paymentEvent = item;
                    this.isPayment = true;
                    this.setLoading(false);
                  }
                });
              }
            }
          );
        })
        .catch(() => {});
    },
    async getInit() {
      try {
        this.setLoading(true);
        const id_transaction_digital =
          this.$route.params.id_transaction_digital;

        if (!id_transaction_digital) {
          this.setLoading(false);
          return this.$toast.error("Não foi possível gerar o QrCode PIX!");
        }

        const contaReceber = await httpResetLogin.post("pix/busca-pix", {
          id_transaction: id_transaction_digital,
        });

        if (!contaReceber.data.qr_code_pix) {
          this.setLoading(false);
          return this.$toast.error("Não foi possível gerar o QrCode PIX!");
        }
        this.id_transaction_digital = id_transaction_digital;
        this.qrCodPix = contaReceber.data.qr_code_pix;
        this.valorPix = contaReceber.data.valor;
        if (contaReceber.data.valor_total > 0) {
          this.valorPix = contaReceber.data.valor_total;
        }
        this.dataValidadePix = contaReceber.data.pix.pix_expiration_date_time;
        this.benificiario = contaReceber.data.empresa.nome;

        this.setLoading(false);
      } catch {
        return;
      }
    },
    async copyQrCode() {
      await navigator.clipboard.writeText(this.qrCodPix);
      this.$toast.success("Código copiado com sucesso!");
    },
  },
  mounted() {
    this.getInit();
    this.verificaContasReceber();
  },
};
